import { Component, Fragment } from 'react'
import {
  Badge,
  CloseButton,
  Inline,
  Heading,
  Hidden,
  Visible,
  Stack,
  Text
} from '@leroy-merlin-br/backyard-react-ui'

import emitter from 'garden/src/js/utils/emitter'

import fetch from 'scripts/utils/fetch'
import { error as errorMessage } from 'scripts/utils/message'
import tryAddToCart from 'scripts/utils/cart/addToCart'

import { Drawer } from 'reactShared/components/Drawer'

import { showSpinner, hideSpinner } from 'reactUtils/Spinner'

import { SellersListItem } from 'catalog/pages/Product/containers/Buybox/components/SellersListItem'
import * as S from 'catalog/pages/Product/containers/Buybox/components/SellersList/styled'

class SellersList extends Component {
  constructor (props) {
    super(props)

    this.fetch = fetch

    this.state = {
      isDrawerOpen: false,
      skus: []
    }
  }

  componentDidMount () {
    emitter.on('buybox:drawer-open', this.toggleDrawer)
  }

  toggleDrawer = () => {
    if (this.state.skus.length === 0) {
      showSpinner()

      return this.fetch(`/product/${this.props.productId}/skus`)
        .then(data => data.json())
        .then(data => this.setState(prevState => ({
          skus: data,
          isDrawerOpen: !prevState.isDrawerOpen
        })))
        .then(hideSpinner())
        .catch(this.showFetchError)
    }

    this.setState(prevState => ({
      isDrawerOpen: !prevState.isDrawerOpen
    }))
  }

  showFetchError = (error) => {
    hideSpinner()

    errorMessage('Não foi possível recuperar os outros preços. Tente novamente mais tarde.')
    console.error('Erro ao requisitar shops do marketplace', error)
  }

  pickupInStoreClick = () => {
    this.toggleDrawer()

    emitter.emit('showStock')
  }

  ecommerceClick = (id, shop, price) => {
    const product = {
      id: this.props.productId,
      quantity: 1
    }

    if (id) {
      product.skuId = id
    }

    tryAddToCart({
      regionId: this.props.regionId,
      type: 'delivery',
      products: [product],
      override: false
    })

    this.toggleDrawer()
  }

  renderSkusList (skus) {
    const productId = this.props.productId

    return skus.map(({ id, shop, price, purchaseButtons, limitQuantity }) => (
      <SellersListItem
        key={id}
        productId={productId}
        id={id}
        shop={shop}
        price={price}
        purchaseButtons={purchaseButtons}
        limitQuantity={limitQuantity}
        pickupInStoreClick={this.pickupInStoreClick}
        closeDrawer={this.toggleDrawer}
      />
    ))
  }

  render () {
    return (
      <Fragment>
        <Drawer
          isOpen={this.state.isDrawerOpen}
          overlayClick={this.toggleDrawer}
          className="sellers-list"
        >
          <S.Wrapper>
            <Stack spacing="mega">
              <Inline spacing="bit" justify="left" align="center" noWrap>
                <CloseButton label="Fechar" onClick={this.toggleDrawer} />

                <S.Title>
                  Compare os preços entre nossas lojas parceiras
                </S.Title>
              </Inline>

              <S.ProductContainer>
                <Inline spacing="giga" justify="left" align="top" noWrap>
                  <S.ProductImage alt={this.props.productName} src={this.props.productImg} />

                  <Stack spacing="byte">
                    <div>
                      <Visible untilKilo kilo>
                        <Heading as="h3" size="kilo" noMargin>
                          {this.props.productName}
                        </Heading>
                      </Visible>

                      <Hidden untilKilo kilo>
                        <Heading as="h3" size="tera" noMargin>
                          {this.props.productName}
                        </Heading>
                      </Hidden>
                    </div>

                    <Badge color="gray">Cód. {this.props.productId}</Badge>
                  </Stack>
                </Inline>
              </S.ProductContainer>
              <Stack spacing="byte">
                <Hidden untilKilo kilo>
                  <S.SkusHeader>
                    <S.SkusHeaderTitle>
                      <Text as="div" size="giga" noMargin bold>
                        Lojas
                      </Text>
                    </S.SkusHeaderTitle>

                    <S.SkusHeaderTitle>
                      <Text as="div" size="giga" noMargin bold>
                        Preço do produto
                      </Text>
                    </S.SkusHeaderTitle>

                    <S.SkusHeaderTitle>
                      <Text as="div" size="giga" noMargin bold>
                        Opções de compra
                      </Text>
                    </S.SkusHeaderTitle>
                  </S.SkusHeader>
                </Hidden>

                {this.renderSkusList(this.state.skus)}
              </Stack>
            </Stack>
          </S.Wrapper>
        </Drawer>
      </Fragment>
    )
  }
}

export default SellersList
